import { render } from "./ChatBodySearch.vue?vue&type=template&id=1a4839eb&scoped=true"
import script from "./ChatBodySearch.vue?vue&type=script&lang=js"
export * from "./ChatBodySearch.vue?vue&type=script&lang=js"

import "./ChatBodySearch.vue?vue&type=style&index=0&id=1a4839eb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4839eb"],['__file',"webpack-assets/vue/templates/chat/parts/ChatBodySearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a4839eb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a4839eb', __exports__)) {
    api.reload('1a4839eb', __exports__)
  }
  
  module.hot.accept("./ChatBodySearch.vue?vue&type=template&id=1a4839eb&scoped=true", () => {
    api.rerender('1a4839eb', render)
  })

}


export default __exports__